import React from 'react';
import {Button, Container, Row, Col} from 'react-bootstrap';

function PaymentResponse() {
    return (
        <div className="bg-gradient-dark" style={{minHeight: "100vh"}}>
            <Container className="d-flex flex-column justify-content-center align-items-center mt-5">
                <Row className="mb-4">
                    <Col className="text-center">
                        <h1 className="display-1 text-white fw-bolder">Thank You!</h1>
                    </Col>
                </Row>
                <Row className="mb-4">
                    <Col className="text-center">
                        <p className="text-white fs-3">
                            Your purchase has been confirmed and you will receive a confirmation email shortly.
                        </p>
                    </Col>
                </Row>
                <Row>
                    <Col className="text-center">
                        <Button variant="warning" href="/">
                            Return Home
                        </Button>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default PaymentResponse;
